module.exports = ".page-header {\n    margin-top: 0px;\n    color: #26273B;\n    border-bottom: none;\n}\n\n.page-header, .nav-btn {\n    display: inline-block;\n}\n\n.nav-btn {\n    vertical-align: top;\n}\n\n.tag {\n    display: inline-block;\n    font-size: 14px;\n    padding: .3em .4em .4em;\n    margin: .2em 0 .1em .1em;\n}\n\n.controls.readonly {\n    padding-top: 7px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/agora/components/account-configurations/add/account-configurations-add.component.css
// module id = ./src/app/agora/components/account-configurations/add/account-configurations-add.component.css
// module chunks = main